module.exports = __webpack_public_path__ + "img/img@2x.da2ed07a.webp";